import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import CompatibilityIcon from 'marketplace-ui-common/compatibility/components/CompatibilityIcon';
import { getTierI18nKey } from 'marketplace-ui-common/utils/i18n';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPricingUrl } from '../../../utils/urls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
// @ts-expect-error untyped dependency
import { getIsCustomer } from '../../../selectors/auth';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureCardCompatibility = ({
  onTrackInteraction,
  missingCompatibilityRequirement,
  openFeatureCompatibilityModal
}) => {
  const isCustomer = useSelector(getIsCustomer);
  const {
    compatibilityType,
    requiredPlanHub,
    requiredPlan,
    multipleHubOptionsAvailable
  } = useMemo(() => {
    if (missingCompatibilityRequirement === 'USER_CONDITIONAL_SCOPE') {
      return {
        compatibilityType: 'COMPATIBLE_SOME'
      };
    } else if (missingCompatibilityRequirement === 'MULTIPLE_HUB_OPTIONS_AVAILABLE') {
      return {
        compatibilityType: 'COMPATIBLE_NONE',
        multipleHubOptionsAvailable: true
      };
    } else if (missingCompatibilityRequirement) {
      return {
        compatibilityType: 'COMPATIBLE_NONE',
        requiredPlanHub: missingCompatibilityRequirement.split('_')[0],
        requiredPlan: missingCompatibilityRequirement
      };
    } else {
      return {
        compatibilityType: 'COMPATIBLE_ALL'
      };
    }
  }, [missingCompatibilityRequirement]);
  const handleExplorePlanOptionsClick = () => {
    onTrackInteraction('click feature required compare by plan link', {
      section: 'overview'
    });
    if (openFeatureCompatibilityModal) {
      openFeatureCompatibilityModal();
    }
  };
  return /*#__PURE__*/_jsxs(MediaObject, {
    align: "start",
    itemLeft: isCustomer ? /*#__PURE__*/_jsx(CompatibilityIcon, {
      compatibilityType: compatibilityType
    }) : undefined,
    spacing: "extra-small",
    "data-test-id": "feature-card-compatibility",
    children: [multipleHubOptionsAvailable && openFeatureCompatibilityModal ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `appMarketplace.detail.overview.integrationFeatures.COMPATIBLE_NONE_MULTIPLE_HUBS_jsx`,
      options: {
        linkProps: {
          onClick: handleExplorePlanOptionsClick
        }
      },
      elements: {
        Bold: 'b',
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `appMarketplace.detail.overview.integrationFeatures.${compatibilityType}_jsx`,
      options: {
        planName: requiredPlan ? I18n.text(getTierI18nKey(requiredPlan)) : '',
        linkProps: {
          external: true,
          href: getPricingUrl(isCustomer, requiredPlanHub),
          onClick: () => onTrackInteraction('click feature required plan compare by plan link', {
            section: 'overview',
            value: requiredPlanHub
          })
        }
      },
      elements: {
        Bold: 'b',
        Link
      }
    }), compatibilityType === 'COMPATIBLE_SOME' ? /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.overview.integrationFeatures.COMPATIBLE_SOME_help"
      }),
      marginInlineStart: "100"
    }) : undefined]
  });
};